<template>
  
<aside 
  id="sidebar-multi-level-sidebar" 
  :class="` fixed top-0 left-0 z-40 w-64 h-screen transition-transform -translate-x-full sm:translate-x-0 sm:hidden md:hidden lg:block xl:block
  `"
  :style="`display: ${ (_flagResize || sidebarOpen) ? 'block' : 'none'} !important;`" 
  >
   <div class="h-full px-3 py-2 overflow-y-auto bg-gray-800 pt-50 ">
      <div class="flex justify-center" >
        <img  src="~/assets/images/logo_sisgex_nav.png" style="height: 60px;" />
      </div>

      <ul class="space-y-2 font-medium mt-5">
        <li v-for="item in _items" :key="'root_'+item.name">
          <NuxtLink 
            :to="item.link" 
            :class="[useRoute().path === item.link ? 'bg-primary-600' : '', 'flex items-center p-2 text-gray-900 rounded-lg text-white hover:bg-gray-700 group']"
            v-if="item.itens.length == 0"
          >
            
            <!--<component v-if="item.icon" :is="item.icon" class="text-primary-600 h-6 w-6 shrink-0" />-->
            <svg 
              v-if="item.icon"
              class="w-5 h-5 shrink-0" 
              xmlns="http://www.w3.org/2000/svg" 
              fill="none" 
              viewBox="0 0 24 24"
            >
               <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" :d="item.icon" />
            </svg>
                
            <span class="ml-3" > {{ item.name }}  </span>
          </NuxtLink>

          <button 
            type="button" 
            class="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-lg group bg-white-100 hover:bg-gray-700 text-white" 
            @click="item['open'] = ! item['open']" 
            v-if="item.itens.length != 0"
          >
                <svg 
                  v-if="item.icon"
                  class="w-5 h-5 shrink-0" 
                  xmlns="http://www.w3.org/2000/svg" 
                  fill="none" 
                  viewBox="0 0 24 24"
                >
                   <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" :d="item.icon" />
                </svg>

                <span class="flex-1 ml-3 text-left whitespace-nowrap"> {{ item.name }} </span>
               
                <svg 
                  class="w-3 h-3" 
                  xmlns="http://www.w3.org/2000/svg" 
                  fill="none" 
                  viewBox="0 0 24 24"
                  v-if="!item['open']"
                >
                   <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                </svg>

                <svg 
                  class="w-3 h-3"
                  xmlns="http://www.w3.org/2000/svg" 
                  fill="none" 
                  viewBox="0 0 24 24" 
                  v-else
                >
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.5 15.75l7.5-7.5 7.5 7.5" />
                </svg>

          </button>

          <ul 
            :class="`${item['open'] ? 'block' : 'hidden'} py-2 space-y-2`"
            v-if="item.itens.length != 0"
          >
            <li v-for="it in item.itens" :key="'sub_'+it.name" >
              <NuxtLink 
                :to="it.link" 
                :class="[useRoute().path === it.link ? 'bg-primary-600' : '', 'flex items-center w-full p-2 text-white hover:bg-gray-700  transition duration-75 rounded-lg pl-11 group']"
              >
                
                <!--<component v-if="it.icon" :is="it.icon" class="text-primary-200 h-6 w-6 shrink-0" />-->
                <svg 
                  v-if="it.icon"
                  class="w-5 h-5 shrink-0" 
                  xmlns="http://www.w3.org/2000/svg" 
                  fill="none" 
                  viewBox="0 0 24 24"
                >
                   <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" :d="it.icon" />
                </svg>
                
                <span class="ml-3" > {{ it.name }}  </span>
              </NuxtLink>
            </li>
          </ul>
        </li>
      </ul>
   </div>
</aside>

</template>

<script lang="ts" setup>
import { ref, onMounted, onUpdated } from "vue";

import {
  Bars3Icon,
  BellIcon,
  CalendarIcon,
  ChartPieIcon,
  Cog6ToothIcon,
  DocumentDuplicateIcon,
  FolderIcon,
  HomeIcon,
  UsersIcon,
  XMarkIcon,
  BuildingOffice2Icon,
  FolderPlusIcon,
  BriefcaseIcon,
  WrenchScrewdriverIcon,
  UserCircleIcon,
} from "@heroicons/vue/24/outline";

const _items = ref([]);
const _sideOpen = ref(false);
const _flagResize = ref(false);

const props = defineProps<{
  itemsNavigation: Array<Object>; // Expects array of objects containing link, name current and icon
  sidebarOpen: boolean;
}>();

function watchResize(){
  let width = window.innerWidth;
  if(width>=1024){
    _flagResize.value = true;
  }
  else{
    _flagResize.value = false;
  }
}

onMounted(() => {
  _items.value = props.itemsNavigation;
  _sideOpen.value = props.sidebarOpen;
  
  window.addEventListener('resize', () => {
    watchResize();
  });
  watchResize();
});

</script>